<template>
  <div>
    <h1>Emergency Contacts</h1>
    <div v-if="contacts.length">
      <table>
        <tr>
          <th>Name</th>
          <th>Relationship</th>
          <th>Email</th>
          <th>Phone</th>
        </tr>
        <tr v-for="contact in contacts" :key="contact.id">
          <td>{{ contact.name }}</td>
          <td>{{ contact.relationship }}</td>
          <td>{{ contact.contact_email }}</td>
          <td>{{ contact.contact_phone }}</td>
        </tr>
      </table>
    </div>
    <p v-else>No emergency contacts found.</p>

    <button class="toggle-button" @click="toggleForm">Add Emergency Contact</button>
    <div v-if="showForm" class="card">
      <h2>Add Emergency Contact</h2>
      <form @submit.prevent="addContact">
        <input type="text" v-model="newContact.name" placeholder="Name">
        <input type="text" v-model="newContact.relationship" placeholder="Relationship">
        <input type="email" v-model="newContact.contact_email" placeholder="Email">
        <input type="text" v-model="newContact.contact_phone" placeholder="Phone">
        <button type="submit" class="add-button">Add Contact</button>
      </form>
    </div>
  </div><br><br><br><br><br><br>
</template>
  
  <script>
  import axios from 'axios';
  import { Auth } from 'aws-amplify';
  
  export default {
    data() {
      return {
        contacts: [],  // Array to store emergency contacts
        newContact: {  // Object for binding form data
          name: '',
          relationship: '',
          contact_email: '',
          contact_phone: '',
        
        },
        showForm: false,
      };
    },
    async mounted() {
      await this.fetchContacts();  // Fetch contacts when component mounts
    },
    methods: {

      async fetchContacts() {
        try {
          const user = await Auth.currentAuthenticatedUser();
          const cognitoSub = user.attributes.sub;
          const config = { headers: { 'X-Cognito-Sub': cognitoSub } };
          const response = await axios.get('https://api.riskypaws.com/frontoffice/api/emergency-contacts/', config);
          this.contacts = response.data;
        } catch (error) {
          console.error('Error fetching emergency contacts:', error);
        }
      },
  
 
      async addContact() {
        try {
          const user = await Auth.currentAuthenticatedUser();
          const cognitoSub = user.attributes.sub;
          const config = { headers: { 'X-Cognito-Sub': cognitoSub } };
          await axios.post('https://api.riskypaws.com/frontoffice/api/emergency-contacts/', this.newContact, config);
          this.resetForm();  // Reset the form after successful submission
          await this.fetchContacts();  // Fetch the updated list of contacts
        } catch (error) {
          console.error('Error adding new contact:', error);
        }
      },
      toggleForm() {
    this.showForm = !this.showForm;
  },
      resetForm() {
        this.newContact = {
          name: '',
          relationship: '',
          contact_email: '',
          contact_phone: ''
        };
      }
    }
  };
  </script>


  <style scoped>
  table {
    width: 100%;
    border-collapse: collapse;
  }

  th, td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }

  th {
    background-color: #f2f2f2;
  }

  .toggle-button, .add-button {
    background-color: purple;
    border: none;
    color: white;
    padding: 10px 20px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 16px;
    margin: 4px 2px;
    cursor: pointer;
    border-radius: 20px;
    transition: background-color 0.3s;
  }

  .toggle-button:hover, .add-button:hover {
    background-color: black;
  }
</style>